import React from "react";
import CheckboxItem from "../../../components/print/workDiary/CheckboxItem";
import { Typography } from "antd";
import { useIntl } from "react-intl";
const { Title } = Typography;

const Statements = (props) => {
  const { employee } = props;
  const work_in_other_company = employee?.work_in_other_company;
  const intl = useIntl();
  return (
    <div
      className="borderedSection statements"
      style={{ width: "100%", marginTop: "10px" }}
    >
      <Title level={5}>
        {intl.formatMessage({
          id: "app.work_diary_print.employee_statements",
        })}
      </Title>
      <div>
        <div className="spacerContainer">
          <div className="rowContainer" style={{ flex: 3 }}>
            <div
              style={{
                display: "table",
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  marginBottom: "5px",
                }}
              >
                <CheckboxItem name="no_reltive_statement" />
                <div className="horizontal_line" />
              </div>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                }}
              >
                <CheckboxItem
                  name="no_other_company_statement"
                  checked={!work_in_other_company}
                />
                <div className="horizontal_line" />
              </div>
            </div>
          </div>

          <div className="rowContainer" style={{ flex: 4 }}>
            <div
              style={{
                display: "table",
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  marginBottom: "5px",
                }}
              >
                <CheckboxItem name="filled_reltive_statement" />
                <div className="horizontal_line" />
              </div>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                }}
              >
                <CheckboxItem
                  name="other_company_statement"
                  checked={work_in_other_company}
                />
                <div className="horizontal_line" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statements;
